import { render, staticRenderFns } from "./article-autoassign-rules.vue?vue&type=template&id=6446daa4&scoped=true"
import script from "./article-autoassign-rules.vue?vue&type=script&lang=js"
export * from "./article-autoassign-rules.vue?vue&type=script&lang=js"
import style0 from "./article-autoassign-rules.vue?vue&type=style&index=0&id=6446daa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446daa4",
  null
  
)

export default component.exports